import { render, staticRenderFns } from "./NCtaLoader.vue?vue&type=template&id=2f40d0be&scoped=true&"
import script from "./NCtaLoader.vue?vue&type=script&lang=js&"
export * from "./NCtaLoader.vue?vue&type=script&lang=js&"
import style0 from "./NCtaLoader.vue?vue&type=style&index=0&id=2f40d0be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40d0be",
  null
  
)

export default component.exports